import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.shouldScroll, action) =>
  action.type === types.SET_SHOULD_SCROLL ? Boolean(action.payload) : state
